export const cameraOptions = [
    { label: 'Tất cả camera', value: 'Tất cả camera' },
    { label: 'Camera 1', value: '101' },
    { label: 'Camera 2', value: '201' },
    { label: 'Camera 3', value: '301' },
    { label: 'Camera 4', value: '401' }
];